// Consistent terms-and-conditions popup used by every "View details" /
// "See Terms and Conditions" / "Learn More" surface that renders the
// FITTINGUS or promo-specific terms. Wraps SimplePopup (navy background
// + white X) and adds scroll behavior for long terms text so the box
// never grows past the modal.

import styles from '../styles/widget.module.css';
import SimplePopup from './SimplePopup';

interface TermsPopupProps {
  isOpen: boolean;
  onClose: () => void;
  /** Optional heading rendered in the SimplePopup's white-on-navy h3. */
  title?: string;
  /** Full terms text. Accepts plain string (renders as a single paragraph)
   *  or arbitrary React nodes for callers that need richer markup
   *  (e.g., a privacy policy link beneath the disclaimer copy). */
  body: React.ReactNode;
  /** Optional positioning override (e.g., to flip above the trigger). */
  className?: string;
}

export function TermsPopup({ isOpen, onClose, title, body, className }: TermsPopupProps) {
  return (
    <SimplePopup
      isOpen={isOpen}
      onClosePopup={onClose}
      className={`${styles.termsPopup} ${className ?? ''}`}
    >
      <div className={styles.termsPopupScroller}>
        {title && <h3>{title}</h3>}
        {typeof body === 'string' ? <p>{body}</p> : body}
      </div>
    </SimplePopup>
  );
}
